import React, {Component} from 'react';
import Endpoint from "./Endpoint";
import { connect } from "react-redux";
import {addSubField} from "../../../../store/actions/subFields";
import {endpointAddNew} from "../../../../store/actions/endpoints";
import {saveCustomRoute} from "../../../../store/actions/customRoute";

const Endpoints = ({ endpoints, endpointAddNew, saveRoute }) => {
	return (<React.Fragment>
		{endpoints.map(
			(endpoint, index) =>
				<Endpoint
					key={index}
					id={index}
					endpoint={endpoint}
				/>)}
		<div style={{clear: 'both'}}/>
	</React.Fragment>);
};

const mapStateToProps = ( state ) => ({
	endpoints: state.settings.endpoints
});

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
	saveRoute: () => dispatch( saveCustomRoute() )
});

export default connect( mapStateToProps, mapDispatchToProps )(Endpoints);